export const MobileCarrier = {
  KT: 'KT',
  LGU: 'LGU',
  SKT: 'SKT',
  HELLO: 'HELLO',
  KCT: 'KCT',
  SK7: 'SK7',
} as const;

export type MobileCarrier = keyof typeof MobileCarrier;
